import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function copyFieldsFrom(reqData) {
  try {
    const res = await post(`${URL.copyFieldsFromForm}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
